export const menuItems = [
  {
    title: 'Quem somos',
    url: '/quem-somos',
  },
  {
    title: 'Qualidade',
    url: '/qualidade',
  },
  {
    title: 'Tratamentos',
    url: '',
    subItems: [
      {
        title: 'Alodine',
        url: '/tratamentos/alodine',
      },
      {
        title: 'Bissulfeto de Molibdênio',
        url: '/tratamentos/bissulfeto',
      },
      {
        title: 'Cádmio',
        url: '/tratamentos/cadmio',
      },
      {
        title: 'Estanho',
        url: '/tratamentos/estanho',
      },
      {
        title: 'Fosfatização',
        url: '/tratamentos/fosfatizacao',
      },
      {
        title: 'Níquel Químico',
        url: '/tratamentos/niquel',
      },
      {
        title: 'Organometálico',
        url: '/tratamentos/organo',
      },
      {
        title: 'Oxidação Negra',
        url: '/tratamentos/oxidacao-negra',
      },
      {
        title: 'Xylan',
        url: '/tratamentos/xylan',
      },
      {
        title: 'Zincagem Eletrolítica',
        url: '/tratamentos/zincagem-eletrolitica',
      },
      {
        title: 'Zincagem a Fogo',
        url: '/tratamentos/zincagem-fogo',
      },
      {
        title: 'Zinco Níquel',
        url: '/tratamentos/zinco-niquel',
      },
    ],
  },
  {
    title: 'Serviços',
    url: '',
    subItems: [
      {
        title: 'Decapagem',
        url: '/servicos/decapagem',
      },
      {
        title: 'Desengraxe',
        url: '/servicos/desengraxe',
      },
      {
        title: 'Jateamento',
        url: '/servicos/jateamento',
      },
    ],
  },
  {
    title: 'Contato',
    url: '/contato',
  },
];
